import React, { RefObject } from 'react'
import { Badge, Box, IconButton, Tooltip, Typography, useTheme } from '@mui/material'
import TuneIcon from '@mui/icons-material/Tune'
import { renderColorByString } from 'components/DataGrid/renderColorByString'
interface CustomViewMenuProps {
  onOpenCustomViews: (event: React.MouseEvent<HTMLElement>) => void
  currentView: string
  badgeColor: string | ''
  icon?: React.ReactNode
  helperRef?: RefObject<HTMLDivElement> // 👈 more specific and compatible
  tooltipTitle?: string
  buttonBgColor?: string
}

const CustomViewsMenu: React.FC<CustomViewMenuProps> = ({
  onOpenCustomViews,
  currentView,
  badgeColor,
  icon,
  helperRef,
  tooltipTitle = 'Custom Views',
  buttonBgColor,
}) => {
  const theme = useTheme()
  return (
    <Box ref={helperRef}>
      <Tooltip title={<Typography>{tooltipTitle}</Typography>} className="custom-views-tooltip">
        <Badge
          badgeContent={
            currentView ? (
              <Typography
                sx={{
                  fontSize: 12,
                  color: renderColorByString(currentView) ?? badgeColor,
                  p: 0.5,
                  borderRadius: '50%',
                  display: 'flex', // Flexbox centering
                  alignItems: 'center', // Vertically center
                  justifyContent: 'center', // Horizontally center
                  fontWeight: 'bold',
                }}
              >
                {currentView}
              </Typography>
            ) : (
              ''
            )
          }
          sx={{
            '.MuiBadge-badge': {
              minWidth: 16,
              height: 16,
              fontSize: '10px',
              padding: 0,
              transform: 'translate(8px, -1px)', // Moves the badge closer to the icon
            },
          }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <IconButton onClick={onOpenCustomViews} sx={{ borderRadius: '0px', bgcolor: buttonBgColor ?? '' }}>
            {icon ? (
              icon
            ) : (
              <>
                <TuneIcon sx={{ fontSize: '30px' }} />
              </>
            )}
          </IconButton>
        </Badge>
      </Tooltip>
    </Box>
  )
}

export default CustomViewsMenu
